<template>
  <div class="transaction-data">
    <div class="container">
      <!-- 筛选条件区域 -->
      <!-- <div class="filter-section">
        <div class="filter-container">
          <div class="date-filters">
            <div
              v-for="item in dateTabs"
              :key="item.value"
              class="date-tab"
              :class="{ active: item.value === queryParams.type }"
              @click="changeDateTab(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div> -->
      <!-- 销售数据概览 -->
      <div class="card">
        <div class="card-header">
          <div class="card-title-wrapper">
            <h3 class="card-title">销售数据概况</h3>
            <el-date-picker
              v-model="saleTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="mini"
              @change="handleSaleTimeRangeChange"
            />
          </div>
          <div class="time-selector">
            <div
              v-for="value in timeRangs"
              :key="value.value"
              class="time-item"
              :class="{ active: saleRealTime === value.value }"
              @click="changeSaleRealTime(value.value)"
            >
              {{ value.label }}
            </div>
          </div>
        </div>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-value">
              {{ saleRealTimeBank.actualMoney || 0 }}
            </div>
            <div class="stat-label">销售额</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">
              {{ saleRealTimeBank.count || 0 }}
            </div>
            <div class="stat-label">订单数</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">
              {{ saleRealTimeBank.refundCount || 0 }}
            </div>
            <div class="stat-label">退货单</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">
              {{ saleRealTimeBank.refundMoney || 0 }}
            </div>
            <div class="stat-label">退货金额</div>
          </div>
        </div>
      </div>

      <!-- 采购数据概览 -->
      <div class="card">
        <div class="card-header">
          <div class="card-title-wrapper">
            <h3 class="card-title">采购数据概况</h3>
            <el-date-picker
              v-model="purchaseTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="mini"
              @change="handlePurchaseTimeRangeChange"
            />
          </div>
          <div class="time-selector">
            <div
              v-for="value in timeRangs"
              :key="value.value"
              class="time-item"
              :class="{ active: purchaseRealTime === value.value }"
              @click="changePurchaseRealTime(value.value)"
            >
              {{ value.label }}
            </div>
          </div>
        </div>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-value">
              {{ purchaseRealTimeBank.actualMoney || 0 }}
            </div>
            <div class="stat-label">采购金额</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ purchaseRealTimeBank.count || 0 }}</div>
            <div class="stat-label">订单数</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">
              {{ purchaseRealTimeBank.refundCount || 0 }}
            </div>
            <div class="stat-label">退货单</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">
              {{ purchaseRealTimeBank.refundMoney || 0 }}
            </div>
            <div class="stat-label">退货金额</div>
          </div>
        </div>
      </div>

      <!-- 销售额趋势 -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">销售额趋势</h3>
          <div class="time-selector">
            <div
              v-for="value in chartTimeRangs"
              :key="value.value"
              class="time-item"
              :class="{ active: saleChartTime === value.value }"
              @click="changeSaleTimeRange(value.value)"
            >
              {{ value.label }}
            </div>
          </div>
        </div>
        <div class="chart-container">
          <div ref="salesChart" class="chart" />
        </div>
      </div>

      <!-- 采购额趋势 -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">采购额趋势</h3>
          <div class="time-selector">
            <div
              v-for="value in chartTimeRangs"
              :key="value.value"
              class="time-item"
              :class="{ active: purchaseChartTime === value.value }"
              @click="changePurchaseTimeRange(value.value)"
            >
              {{ value.label }}
            </div>
          </div>
        </div>
        <div class="chart-container">
          <div ref="purchaseChart" class="chart" />
        </div>
      </div>

      <!-- 售后原因 -->
      <!-- <div class="card">
        <div class="card-header">
          <h3 class="card-title">售后原因</h3>
        </div>
        <div class="chart-container">
          <div ref="refundChart" class="chart" />
        </div>
      </div> -->

      <!-- 商品排行榜 -->
      <!-- <div class="card">
        <div class="card-header">
          <h3 class="card-title">商品排行榜</h3>
          <div class="time-selector">
            <div
              class="time-item"
              :class="{ active: productRankTime === 1 }"
              @click="changeProductRankTime(1)"
            >
              当天
            </div>
            <div
              class="time-item"
              :class="{ active: productRankTime === 2 }"
              @click="changeProductRankTime(2)"
            >
              一周
            </div>
            <div
              class="time-item"
              :class="{ active: productRankTime === 3 }"
              @click="changeProductRankTime(3)"
            >
              一个月
            </div>
          </div>
        </div>
        <div class="table-container">
          <el-table
            :data="productRankList"
            stripe
            size="small"
            class="rank-table"
          >
            <el-table-column prop="rank" label="排名" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="productName"
              label="商品名称"
              min-width="100"
            />
            <el-table-column
              prop="productPrice"
              label="销售额(元)"
              min-width="120"
              align="right"
            />
          </el-table>
        </div>
      </div> -->

      <!-- 店铺排行榜 -->
      <!-- <div class="card">
        <div class="card-header">
          <h3 class="card-title">店铺排行榜</h3>
          <div class="time-selector">
            <div
              class="time-item"
              :class="{ active: shopRankTime === 1 }"
              @click="changeShopRankTime(1)"
            >
              当天
            </div>
            <div
              class="time-item"
              :class="{ active: shopRankTime === 2 }"
              @click="changeShopRankTime(2)"
            >
              一周
            </div>
            <div
              class="time-item"
              :class="{ active: shopRankTime === 3 }"
              @click="changeShopRankTime(3)"
            >
              一个月
            </div>
          </div>
        </div>
        <div class="table-container">
          <el-table :data="shopRankList" stripe size="small" class="rank-table">
            <el-table-column prop="rank" label="排名" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="shopName" label="店铺名称" min-width="100" />
            <el-table-column
              prop="productPrice"
              label="销售额(元)"
              min-width="120"
              align="right"
            />
          </el-table>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import eventBus from '@/utils/eventBus';
import {
  api_realTimeBank,
  api_listShopOrderRankingBank,
  api_sumOrderChatBank,
  api_realTimePurchaseBank,
  api_sumPurchaseChatBank
} from '@/api/index';

export default {
  name: 'Home',
  data() {
    return {
      queryParams: {
        type: 1
      },
      dateTabs: [
        {
          label: '全部',
          value: 1
        },
        {
          label: '销售',
          value: 2
        },
        {
          label: '采购',
          value: 3
        }
      ],
      timeRangs: [
        // {
        //   label: '当天',
        //   value: 1
        // },
        {
          label: '月',
          value: 1
        },
        {
          label: '季度',
          value: 2
        },
        {
          label: '半年',
          value: 3
        },
        {
          label: '年',
          value: 4
        }
      ],
      chartTimeRangs: [
        {
          label: '7天',
          value: 0
        },
        {
          label: '30天',
          value: 1
        }
      ],
      saleRealTime: 1,
      saleTimeRange: [],
      saleRealTimeBank: {},
      salesChart: null,
      purchaseRealTime: 1,
      purchaseTimeRange: [],
      purchaseRealTimeBank: {},
      purchaseChart: null,
      saleChartTime: 1,
      purchaseChartTime: 1,
      chartData: {
        dates: [],
        sales: [],
        refunds: []
      },
      purchaseChartData: {
        dates: [],
        sales: [],
        refunds: []
      },
      // 商品排行榜
      productRankTime: 3, // 默认一周
      productRankList: [],
      // 店铺排行榜
      shopRankTime: 3, // 默认一周
      shopRankList: []
    };
  },
  mounted() {
    this.saleTimeRange = this.calculateTimeRange(this.saleRealTime);
    this.purchaseTimeRange = this.calculateTimeRange(this.purchaseRealTime);
    this.initSalesChart();
    this.initPurchaseChart();
    this.getSalesData();
    this.getPurchaseData();
    this.getRealTimeBank();
    this.getPurchaseRealTimeBank();
    window.addEventListener('resize', this.handleResize);

    // 订阅企业切换事件
    eventBus.$on('enterpriseChanged', this.handleEnterpriseChange);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);

    // 取消订阅企业切换事件
    eventBus.$off('enterpriseChanged', this.handleEnterpriseChange);
  },
  methods: {
    initPurchaseChart() {
      if (!this.purchaseChart) {
        this.purchaseChart = echarts.init(this.$refs.purchaseChart);
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['采购金额', '退款额'],
            bottom: 0
          },
          grid: {
            left: '3%',
            right: '4%',
            top: '3%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: 'value',
            min: 0
          },
          series: [
            {
              name: '采购金额',
              type: 'line',
              data: [],
              smooth: true,
              lineStyle: {
                color: '#5470c6'
              }
            },
            {
              name: '退款额',
              type: 'line',
              data: [],
              smooth: true,
              lineStyle: {
                color: '#ee6666'
              }
            }
          ]
        };
        this.purchaseChart.setOption(option);
      }
    },
    // 切换采购实时时间范围
    changePurchaseRealTime(time) {
      this.purchaseRealTime = time;
      this.purchaseTimeRange = this.calculateTimeRange(time);
      this.getPurchaseRealTimeBank();
    },
    // 采购时间范围手动选择变化
    handlePurchaseTimeRangeChange(val) {
      if (val && val.length === 2) {
        this.getPurchaseRealTimeBank();
      }
    },
    // 获取采购数据
    async getPurchaseData() {
      try {
        const res = await api_sumPurchaseChatBank({
          type: this.purchaseChartTime
        });
        if (res && res.data) {
          this.purchaseChartData = {
            dates: res.data.moneyChat.map((item) => item.applicableDate),
            sales: res.data.moneyChat.map((item) => item.money),
            refunds: res.data.moneyChat.map((item) => item.refundMoney)
          };
          this.updatePurchaseChart();
        }
      } catch (error) {
        console.error('获取采购数据失败:', error);
        this.purchaseChartData = {
          dates: ['2025-11-25', '2025-11-26', '2025-11-27'],
          sales: [0, 0, 60],
          refunds: [0, 0, 0]
        };
        this.updatePurchaseChart();
      }
    },
    // 更新采购图表
    updatePurchaseChart() {
      if (this.purchaseChart) {
        this.purchaseChart.setOption({
          xAxis: {
            data: this.purchaseChartData.dates
          },
          series: [
            {
              data: this.purchaseChartData.sales
            },
            {
              data: this.purchaseChartData.refunds
            }
          ]
        });
      }
    },
    // 切换采购时间范围
    changePurchaseTimeRange(time) {
      this.purchaseChartTime = time;
      this.getPurchaseData();
    },
    // 切换销售额时间范围
    changeSaleTimeRange(time) {
      this.saleChartTime = time;
      this.getSalesData();
    },
    // 获取店铺排行榜
    getShopRankList() {
      api_listShopOrderRankingBank({ type: this.shopRankTime }).then((res) => {
        if (res && res.data) {
          this.shopRankList = res.data;
        }
      });
    },
    // 处理企业切换
    handleEnterpriseChange() {
      // 重新获取所有数据
      this.getSalesData();
      this.getPurchaseData();
      this.getRealTimeBank();
      this.getPurchaseRealTimeBank();
      // this.getShopRankList();
    },
    // 获取采购实时银行数据
    getPurchaseRealTimeBank() {
      const params = { queryType: this.purchaseRealTime };
      if (this.purchaseTimeRange && this.purchaseTimeRange.length === 2) {
        params.startTime = this.purchaseTimeRange[0];
        params.endTime = this.purchaseTimeRange[1];
      }
      api_realTimePurchaseBank(params).then((res) => {
        if (res && res.data) {
          this.purchaseRealTimeBank = res.data;
        }
      });
    },
    getRealTimeBank() {
      const params = { queryType: this.saleRealTime };
      if (this.saleTimeRange && this.saleTimeRange.length === 2) {
        params.startTime = this.saleTimeRange[0];
        params.endTime = this.saleTimeRange[1];
      }
      api_realTimeBank(params).then((res) => {
        if (res && res.data) {
          this.saleRealTimeBank = res.data;
        }
      });
    },
    initSalesChart() {
      if (!this.salesChart) {
        this.salesChart = echarts.init(this.$refs.salesChart);
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['销售额', '退款额'],
            bottom: 0
          },
          grid: {
            left: '3%',
            right: '4%',
            top: '3%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: 'value',
            min: 0
          },
          series: [
            {
              name: '销售额',
              type: 'line',
              data: [],
              smooth: true,
              lineStyle: {
                color: '#5470c6'
              }
            },
            {
              name: '退款额',
              type: 'line',
              data: [],
              smooth: true,
              lineStyle: {
                color: '#ee6666'
              }
            }
          ]
        };
        this.salesChart.setOption(option);
      }
    },
    // 切换销售实时时间范围
    changeSaleRealTime(time) {
      this.saleRealTime = time;
      this.saleTimeRange = this.calculateTimeRange(time);
      this.getRealTimeBank();
    },
    // 销售时间范围手动选择变化
    handleSaleTimeRangeChange(val) {
      if (val && val.length === 2) {
        this.getRealTimeBank();
      }
    },
    // 根据类型计算时间范围
    calculateTimeRange(type) {
      const end = new Date();
      const start = new Date();
      switch (type) {
        case 1: // 月
          start.setMonth(start.getMonth() - 1);
          break;
        case 2: // 季度
          start.setMonth(start.getMonth() - 3);
          break;
        case 3: // 半年
          start.setMonth(start.getMonth() - 6);
          break;
        case 4: // 年
          start.setFullYear(start.getFullYear() - 1);
          break;
      }
      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };
      return [formatDate(start), formatDate(end)];
    },
    // 获取销售数据
    async getSalesData() {
      try {
        const res = await api_sumOrderChatBank({ type: this.saleChartTime });
        if (res && res.data) {
          this.chartData = {
            dates: res.data.moneyChat.map((item) => item.applicableDate),
            sales: res.data.moneyChat.map((item) => item.money),
            refunds: res.data.moneyChat.map((item) => item.refundMoney)
          };
          this.updateSalesChart();
        }
      } catch (error) {
        console.error('获取销售数据失败:', error);
        // 使用模拟数据
        this.chartData = {
          dates: ['2025-11-25', '2025-11-26', '2025-11-27'],
          sales: [0, 0, 60],
          refunds: [0, 0, 0]
        };
        this.updateSalesChart();
      }
    },
    updateSalesChart() {
      if (this.salesChart) {
        this.salesChart.setOption({
          xAxis: {
            data: this.chartData.dates
          },
          series: [
            {
              data: this.chartData.sales
            },
            {
              data: this.chartData.refunds
            }
          ]
        });
      }
    },
    // 切换时间范围
    changeTimeRange(range) {
      this.params.type = range;
      this.getSalesData();
    },
    // 初始化售后图表
    initRefundChart() {
      if (!this.refundChart) {
        this.refundChart = echarts.init(this.$refs.refundChart);
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['退款额'],
            bottom: 0
          },
          grid: {
            left: '3%',
            right: '4%',
            top: '3%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [
              '无理由',
              '不喜欢',
              '发错货',
              '价格',
              '其他',
              '质量问题',
              '尺寸问题'
            ]
          },
          yAxis: {
            type: 'value',
            min: 0
          },
          series: [
            {
              name: '退款额',
              type: 'line',
              data: [4, 3, 2, 5, 3, 2, 6],
              smooth: true,
              lineStyle: {
                color: '#ee6666'
              }
            }
          ]
        };
        this.refundChart.setOption(option);
      }
    },
    // 获取售后数据
    async getRefundData() {
      try {
        const res = await api_sumOrderChatBank(this.params);
        if (res && res.data) {
          this.chartData = {
            dates: res.data.moneyChat.map((item) => item.applicableDate),
            sales: res.data.moneyChat.map((item) => item.money),
            refunds: res.data.moneyChat.map((item) => item.refundMoney)
          };
          this.updateRefundChart();
        }
      } catch (error) {
        console.error('获取售后数据失败:', error);
        // 使用模拟数据
        this.chartData = {
          dates: ['2025-11-25', '2025-11-26', '2025-11-27'],
          sales: [0, 0, 60],
          refunds: [0, 0, 0]
        };
        this.updateRefundChart();
      }
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.salesChart) {
        this.salesChart.resize();
      }
      if (this.purchaseChart) {
        this.purchaseChart.resize();
      }
    },
    // 商品排行榜时间切换
    changeProductRankTime(time) {
      this.productRankTime = time;
      this.getProductRankList();
    },
    // 店铺排行榜时间切换
    changeShopRankTime(time) {
      this.shopRankTime = time;
      // this.getShopRankList();
    }
  }
};
</script>

<style scoped>
.transaction-data {
  padding: 0 0;
}

.transaction-data h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 筛选条件区域样式 */
.filter-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-container {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}
.date-filters {
  display: flex;
  gap: 10px;
  /* margin-bottom: 15px; */
  flex-wrap: wrap;
  align-items: center;
}

.date-tab {
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #f0f0f0;
  color: #666;
}

.date-tab.active {
  background-color: #5470c6;
  color: #fff;
}
/* 标签页样式 */
.tabs {
  display: flex;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-item {
  flex: 1;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  color: #666;
}

.tab-item.active {
  background-color: #ff7f50;
  color: #fff;
}

/* 卡片样式 */
.card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 0;
}

/* 统计数据网格 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #5470c6;
  margin-bottom: 5px;
}

.stat-change {
  font-size: 12px;
  margin-bottom: 5px;
}

.stat-change .down {
  color: #ee6666;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

/* 时间选择器 */
.time-selector {
  display: flex;
  gap: 10px;
}

.time-item {
  padding: 6px 12px;
  background-color: #f0f0f0;
  border-radius: 15px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.time-item.active {
  background-color: #5470c6;
  color: #fff;
}

/* 图表容器 */
.chart-container {
  width: 100%;
  height: 300px;
}

.chart {
  width: 100%;
  height: 100%;
}

/* 表格容器 */
.table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 10px;
}

/* 排行榜表格 */
.rank-table {
  width: 100%;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 0;
  }

  /* 筛选条件响应式 */
  .filter-section {
    padding: 12px 15px;
  }

  .filter-container {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  .date-filters {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 8px;
  }
  .filter-item {
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-item {
    padding: 10px;
  }

  .stat-value {
    font-size: 20px;
  }

  .card {
    padding: 15px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .chart-container {
    height: 250px;
  }

  .table-container {
    margin-top: 15px;
  }

  .rank-table {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .chart-container {
    height: 200px;
  }

  .rank-table {
    font-size: 10px;
  }
}
</style>
